import React from 'react';
import { RocketIcon } from '@primer/octicons-react';

import BlankSlate from '../../common/BlankSlate/BlankSlate';
import Icon from '../../common/icons/Icon';

import { getThemeColor } from '../../../utils/theme-utils';

const NoTasksGraphic = () => (
  <Icon
    fill={getThemeColor('brand')}
    icon={RocketIcon}
    size={64}
  />
)

export const NoTasksSlate = ({
  mainText = "We couldn't find any tasks for this orchestration."
}) => (
  <BlankSlate
    className="p-4"
    mainText={mainText}
    Graphic={NoTasksGraphic}
  />
)

export default NoTasksSlate;
